import _defineProperty from "/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { animate } from "framer-motion";
import { clamp } from "lodash-es";
import { useCallback } from "react";
var animationDefaults = {
  type: "spring",
  bounce: 0.2
};
/**
 * Obtain a function for smooth window scrolling, based on framer motion.
 * Comes with reasonable defaults, but can be fine-tuned for your needs.
 *
 * @example
 * ```
 * const scrollFn = useSmoothWindowScroll({
 *   animationOptions: {
 *     duration: 1.5,
 *   },
 *   defaultOffset: headerHeight + 20,
 * });
 *
 * const onClick = (event) => scrollFn(event.target)
 * ```
 */

export var useSmoothWindowScroll = function useSmoothWindowScroll(config) {
  var defaultOffset = (config === null || config === void 0 ? void 0 : config.defaultOffset) || 100;
  var animationSettings = (config === null || config === void 0 ? void 0 : config.animationOptions) || animationDefaults;
  return useCallback(function (target, offset) {
    var targetHeight = typeof target === "number" ? target : window.scrollY + target.getBoundingClientRect().top;
    var offsetToUse = offset !== undefined ? offset : defaultOffset;
    var targetValue = clamp(targetHeight - offsetToUse, 0, Infinity);
    animate(window.scrollY, targetValue, _objectSpread(_objectSpread({}, animationSettings), {}, {
      onUpdate: function onUpdate(v) {
        window.scroll(0, v);
      }
    }));
  }, [animationSettings, defaultOffset]);
};